import { Row, Col } from 'react-bootstrap';
import { IManagingLinuxServiceInstance } from '../../api/models';
import { ApiDataWrapper } from '../UIExtentions/ApiDataWrapper';

interface LinuxServiceInfoViewProps {
    isLoading: boolean;
    errorMessage: string;
    isDataNotFound: boolean;
    applicationName: string;
    serverApp: IManagingLinuxServiceInstance;
}
export const LinuxServiceInfoView = ({ isLoading, errorMessage, isDataNotFound, applicationName, serverApp }: LinuxServiceInfoViewProps) => {
    return (
        <>
            <ApiDataWrapper objectType="Install Info" objectName={applicationName} isLoading={isLoading} isDataNotFound={isDataNotFound} errorMessage={errorMessage}>
                <ServerLinuxServiceDetails serverApp={serverApp} />
            </ApiDataWrapper>
        </>
    );
};

interface ServerLinuxServiceDetailsProps {
    serverApp: IManagingLinuxServiceInstance;
}
export function ServerLinuxServiceDetails({ serverApp }: ServerLinuxServiceDetailsProps) {
    return (
        <>
            <Row>
                <Col sm={3}>Unit File State:</Col>
                <Col>{serverApp.unitFileState}</Col>
            </Row>
            <Row>
                <Col sm={3}>Load State:</Col>
                <Col>{serverApp.loadState}</Col>
            </Row>
            <Row>
                <Col sm={3}>Active State:</Col>
                <Col>{serverApp.activeState}</Col>
            </Row>
            <Row>
                <Col sm={3}>Sub State:</Col>
                <Col>{serverApp.subState}</Col>
            </Row>
            <Row>
                <Col sm={3}>User:</Col>
                <Col>{serverApp.user}</Col>
            </Row>
            <Row>
                <Col sm={3}>Control Group:</Col>
                <Col>{serverApp.controlGroup}</Col>
            </Row>
            <Row>
                <Col sm={3}>Exec Start:</Col>
                <Col>
                    <span style={{ lineBreak: 'anywhere' }}>{serverApp.execStart}</span>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>Working Directory:</Col>
                <Col>
                    <span style={{ lineBreak: 'anywhere' }}>{serverApp.workingDirectory}</span>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>Fragment Path:</Col>
                <Col>
                    <span style={{ lineBreak: 'anywhere' }}>{serverApp.fragmentPath}</span>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>Main PID:</Col>
                <Col>{serverApp.mainPid}</Col>
            </Row>
        </>
    );
}
